export const formatNotificationTime = (createdAt: string | Date): string => {
  const now = new Date();
  const notificationDate = new Date(createdAt);
  const diffInMs = now.getTime() - notificationDate.getTime();
  const diffInMinutes = Math.floor(diffInMs / (1000 * 60));
  const diffInHours = Math.floor(diffInMs / (1000 * 60 * 60));

  // Check if it's today
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const notificationDay = new Date(
    notificationDate.getFullYear(),
    notificationDate.getMonth(),
    notificationDate.getDate(),
  );

  if (notificationDay.getTime() === today.getTime()) {
    // Today - show time in minutes/hours format
    if (diffInMinutes < 60) {
      return `${diffInMinutes}m`;
    } else {
      return `${diffInHours}h`;
    }
  } else {
    // Previous days - calculate calendar day difference
    const daysDifference = Math.floor(
      (today.getTime() - notificationDay.getTime()) / (1000 * 60 * 60 * 24),
    );

    if (daysDifference === 1) {
      return 'Yesterday';
    } else if (daysDifference <= 7) {
      return `${daysDifference} days ago`;
    } else {
      // More than a week ago - show date
      return notificationDate.toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
      });
    }
  }
};

export const getNotificationTypeLabel = (type: string): string => {
  const typeLabels: Record<string, string> = {
    CASE_ASSIGNED: 'Case Assigned',
    CASE_MENTIONED: 'Mentioned in Case',
    CASE_APPROVED: 'Case Approved',
    CASE_REASSIGNED: 'Case Reassigned',
    CASE_REJECTED: 'Case Rejected',
    CASE_REOPENED: 'Case Reopened',
    CASE_UPDATED: 'Case Updated',
    TASK_ASSIGNED: 'Task Assigned',
    TASK_MENTIONED: 'Mentioned in Task',
    TASK_COMPLETED: 'Task Completed',
    TASK_UPDATED: 'Task Updated',
  };

  return typeLabels[type] || type;
};
